<template>
  <BModal
    id="modal-private-action"
    ref="modal-private-action"
    no-stacking
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    size="md"
    hide-header
  >
    <div
      v-if="modalValue.titleModal !== 'Log Riwayat'"
      class="text-center text-black"
    >
      <div class="pt-3">
        <div
          class="text-24-bold"
        >
          {{ modalValue.titleModal }}
        </div>
        <br>
        <div
          class="text-16-normal"
        >
          Kamu akan melakukan {{ subtitle(modalValue.subTitle) }} untuk partner pastikan nominal dan catatan sesuai dengan tujuanmu
        </div>
        <br>
        <div class="text-start mx-1">
          <div class="mb-1">
            Nominal
          </div>
          <b-input-group
            class="mb-1"
            prepend="Rp"
          >
            <b-form-input
              v-model="showNominal"
              placeholder="xx.xxxx"
              type="text"
              @keypress="isNumber($event)"
              @keydown="handleKeyDown"
              @input="formatThousand"
              @paste.prevent="checkPaste"
            />
          </b-input-group>
          <div class="mb-1">
            Jenis Transaksi
          </div>
          <b-form-input
            v-model="modalValue.subTitle"
            class="mb-1"
            disabled
          />
          <div
            v-if="modalValue.titleModal === 'Transfer Saldo'"
            class="mb-1"
          >
            <div class="mb-1">
              Email Penerima Transfer
            </div>
            <v-select
              v-model="modalValue.email"
              :options="listEmailClean"
              label="email"
              :clearable="false"
              placeholder="Pilih Email Penerima Transfer"
              @input="setEmail"
            >
              <template #option="option">
                {{ option.email }} - Saldo : {{ IDR(option.kmpoin) }}
              </template>
            </v-select>
          </div>
          <div class="mb-1">
            Catatan Transaksi
          </div>
          <b-form-textarea
            v-model="modalValue.notes"
            :placeholder="modalValue.placeholderNotes"
            :formatter="validMaxLength"
          />
          <div class="d-flex justify-between text-sm">
            <div class="text-muted">
              {{ modalValue.notes.length }}/250
            </div>
          </div>
        </div>
        <div class="my-1 mt-5">
          <BButton
            variant="outline-primary"
            class="w-44"
            @click="closeModal"
          >
            Batal
          </BButton>
          <BButton
            :variant="modalValue.notes.length < 3 || disableBtn || modalValue.emailRequired ? 'secondary' : 'primary'"
            class="ml-1 w-44"
            :disabled="modalValue.notes.length < 3 || disableBtn || modalValue.emailRequired"
            @click.once="onFinish"
          >
            <BSpinner
              v-if="isLoading"
              variant="light"
              small
            />
            Terapkan
          </BButton>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import { isNumber } from '@/libs/helpers'
import { IDR } from '@/libs/currency'
import vSelect from 'vue-select'
import { TIME, DDMMYYYY } from '@/libs/filterDate'

export default {
  components: { BButton, BSpinner, vSelect },
  props: {
    modalValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      disableBtn: true,
      isNumber,
      IDR,
      TIME,
      DDMMYYYY,
      showNominal: null,
      inputValue: '',
    }
  },
  computed: {
    listEmailClean() {
      return (this.modalValue.listEmail || [])
        .filter(o => o && typeof o === 'object' && o.email)
        .map(o => ({ ...o, kmpoin: o.kmpoin ?? 0 }))
    },
  },
  methods: {
    onFinish() {
      this.isLoading = true
      this.disableBtn = true
      this.$bvModal.show('modal-pin-custom')
      this.showNominal = null
      this.inputValue = ''
      this.isLoading = false
      this.disableBtn = false
    },
    closeModal() {
      this.isLoading = false
      this.disableBtn = true
      this.showNominal = null
      this.inputValue = ''
      this.modalValue.notes = ''
      this.modalValue.email = ''
      this.modalValue.nominal = 0
      this.modalValue.emailRequired = false
      this.$nextTick(() => {
        this.$bvModal.hide('modal-private-action')
      })
    },
    setEmail(value) {
      this.modalValue.email = value.email
      if (this.modalValue.email !== '') {
        this.modalValue.emailRequired = false
      }
    },
    formatThousand() {
      this.inputValue = this.showNominal.replace(/\D/g, '')
      const numberValue = parseFloat(this.inputValue) ? parseFloat(this.inputValue) : 0
      const formattedValue = numberValue.toLocaleString()

      if ((this.modalValue.titleModal === 'Pengurangan Saldo' || this.modalValue.titleModal === 'Top Up Saldo') && this.inputValue.length <= 9) {
        this.showNominal = formattedValue
        this.modalValue.nominal = numberValue
      } else if (numberValue >= this.modalValue.kmpoin) {
        this.showNominal = this.modalValue.kmpoin.toLocaleString()
        this.modalValue.nominal = this.modalValue.kmpoin
      } else {
        this.showNominal = formattedValue
        this.modalValue.nominal = numberValue
      }

      if (this.modalValue.nominal === 0 || this.showNominal === '') {
        this.disableBtn = true
      } else {
        this.disableBtn = false
      }
    },
    handleKeyDown(event) {
      let lengthValue = 0
      if (this.modalValue.titleModal === 'Top Up Saldo' || this.modalValue.titleModal === 'Pengurangan Saldo') {
        lengthValue = 9
      } else {
        lengthValue = this.modalValue.kmpoin.toString().length
      }
      if (this.inputValue.length >= lengthValue && event.key !== 'Backspace' && event.key !== 'Delete') {
        event.preventDefault()
      }
    },
    subtitle(value) {
      return value.toLowerCase()
    },
    checkPaste(e) {
      const data = e.clipboardData.getData('Text')
      this.inputValue = data.replace(/\D/g, '')
      const numberValue = parseFloat(this.inputValue) ? parseFloat(this.inputValue) : 0
      this.showNominal = numberValue.toLocaleString()
      this.formatThousand()
    },
    validMaxLength(e) {
      return String(e).substring(0, 250)
    },
  },
}
</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
</style>
